import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { UserProvider } from "./components/UserProvider";
import { MeetingProvider } from "./components/MeetingProvider";
import { CookiesProvider } from "react-cookie";
import { HelmetProvider } from "react-helmet-async";

import BrandMetadata from "./components/BrandMetadata";

import "./index.css";

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <HelmetProvider>
        <BrandMetadata />
        <CookiesProvider>
          <UserProvider>
            <MeetingProvider>
              <App />
            </MeetingProvider>
          </UserProvider>
        </CookiesProvider>
      </HelmetProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
